import request from "../utils/request";

export function login(email, password) {
    return request.post("/users/login", {
        email: email,
        password: password,
    });
}

export function passwordlessLogin(email, passwordlessLoginToken) {
    return request.post(
        "/users/passwordless-login-verify",
        {
            email,
            passwordlessLoginToken,
        },
        { timeout: 60000 }
    );
}

export function forgotPassword(email) {
    return request.post("/users/forgot-password", {
        email,
    });
}

export function passwordlessLoginRequest(email) {
    return request.post("/users/passwordless-login", {
        email,
    });
}

export function resetPassword(password, token, isPasswordless = false) {
    return request.post("/users/reset-password", {
        password,
        token,
        isPasswordless,
    });
}

export async function profile() {
    return await request.get("/users/me");
}

export async function adminProfile() {
    return await request.get("/adminUsers/me");
}

export function logout() {
    return request.get("logout");
}
